import { UilBuilding, UilUsersAlt } from '@iconscout/react-unicons';
import { Menu } from 'antd';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';

import UilEllipsisV from '@iconscout/react-unicons/icons/uil-ellipsis-v';
import propTypes from 'prop-types';
// import versions from '../demoData/changelog.json';
import { changeDirectionMode, changeLayoutMode, changeMenuMode } from '../redux/themeLayout/actionCreator';
import {
  MUHENDIS,
  FIRMA,
  SUBE_MUDURU,
  KAMU_MUHENDISI,
  KOMISYON_UYESI,
  KOMISYON_YEDEK_UYESI,
  UYGULAMA_YONETICISI,
  BAKANLIK_DAIRE_BASKANI,
  GENEL_MUDUR,
  GENEL_MUDUR_YARDIMCISI,
  IL_MUDURU,
  IL_MUDUR_YARDIMCISI,
  IL_SUBE_MUDURU,
} from '../constants/roleConstant';
import { useAuth } from '../hooks/useAuth';
import NotificationHelper from '../utility/notificationHelper';
import { DataService } from '../config/dataService/dataService_yerbis';
import YerbisConstants from '../constants/yerbisConstants';
import KullaniciTayinIslemi from './KullaniciTayinIslemi';
import ProjeDurumDegistir from './ProjeDurumDegistir';
import ProjeYonetimi from './ProjeYonetimi';
import ReferansNoOlustur from './ReferansNoOlustur';

function MenuItems({ toggleCollapsed }) {
  const { t } = useTranslation();
  const { hasRoles, hasTypes, user } = useAuth();
  const [loading, setLoading] = useState(false);
  const [projeDurumDegistirVisible, setProjeDurumDegistirVisible] = useState(false);
  const [projeYonetimiVisible, setProjeYonetimiVisible] = useState(false);
  const [referansNoOlusturVisible, setReferansNoOlusturVisible] = useState(false);

  function getItem(label, key, icon, children, type) {
    return {
      key,
      icon,
      children,
      label,
      type,
    };
  }

  const { topMenu } = useSelector((state) => {
    return {
      topMenu: state.ChangeLayoutMode.topMenu,
    };
  });

  const dispatch = useDispatch();

  const path = '/admin';

  const pathName = window.location.pathname;
  const pathArray = pathName ? pathName.split(path) : [];
  const mainPath = pathArray.length > 1 ? pathArray[1] : '';
  const mainPathSplit = mainPath.split('/');

  const [openKeys, setOpenKeys] = React.useState(
    !topMenu ? [`${mainPathSplit.length > 2 ? mainPathSplit[1] : 'dashboard'}`] : [],
  );

  const onOpenChange = (keys) => {
    setOpenKeys(keys[keys.length - 1] !== 'recharts' ? [keys.length && keys[keys.length - 1]] : keys);
  };

  const onClick = (item) => {
    if (item.keyPath.length === 1) setOpenKeys([]);
  };

  const changeLayout = (mode) => {
    dispatch(changeLayoutMode(mode));
  };
  const changeNavbar = (topMode) => {
    const html = document.querySelector('html');
    if (topMode) {
      html.classList.add('ninjadash-topmenu');
    } else {
      html.classList.remove('ninjadash-topmenu');
    }
    dispatch(changeMenuMode(topMode));
  };
  const changeLayoutDirection = (rtlMode) => {
    if (rtlMode) {
      const html = document.querySelector('html');
      html.setAttribute('dir', 'rtl');
    } else {
      const html = document.querySelector('html');
      html.setAttribute('dir', 'ltr');
    }
    dispatch(changeDirectionMode(rtlMode));
  };

  const darkmodeActivated = () => {
    document.body.classList.add('dark-mode');
  };

  const darkmodeDiactivated = () => {
    document.body.classList.remove('dark-mode');
  };

  const fetchAndDownloadExcel = async () => {
    setLoading(true);
    try {
      const response = await DataService.getBlob(
        `${process.env.REACT_APP_PERSONEL_PROJE_DURUMLARI_EXCEL_EXPORT_ENDPOINT}`,
      );

      const blob = new Blob([response.data], { type: response.headers['content-type'] });
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');

      link.href = downloadUrl;
      link.setAttribute('download', 'PersonelProjeDurumlari.xlsx');

      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(downloadUrl);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      NotificationHelper.setErrorNotification(t('processUnexpectedError'));
    }
  };

  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  // Modal'ı kapama işlevi
  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const items = [
    hasRoles([
      MUHENDIS,
      FIRMA,
      SUBE_MUDURU,
      KAMU_MUHENDISI,
      KOMISYON_UYESI,
      KOMISYON_YEDEK_UYESI,
      UYGULAMA_YONETICISI,
      BAKANLIK_DAIRE_BASKANI,
      GENEL_MUDUR,
      GENEL_MUDUR_YARDIMCISI,
      IL_MUDURU,
      IL_MUDUR_YARDIMCISI,
    ]) &&
      getItem(t('menu.proje'), 'projeYonetimi', !topMenu && <UilUsersAlt />, [
        hasRoles([
          SUBE_MUDURU,
          KAMU_MUHENDISI,
          KOMISYON_UYESI,
          KOMISYON_YEDEK_UYESI,
          UYGULAMA_YONETICISI,
          BAKANLIK_DAIRE_BASKANI,
          IL_MUDURU,
          IL_MUDUR_YARDIMCISI,
        ]) &&
          getItem(
            <NavLink onClick={toggleCollapsed} to={`${path}/proje/projelist/taslaklarim`}>
              {t('menu.proje.taslaklarim')}
            </NavLink>,
            'taslaklarim',
            null,
          ),

        hasRoles([UYGULAMA_YONETICISI, FIRMA]) &&
          getItem(
            <NavLink onClick={toggleCollapsed} to={`${path}/pages/wizards/proje`}>
              {t('menu.proje.yeniProje')}
            </NavLink>,
            'yeniProje',
            null,
          ),

        hasRoles([
          MUHENDIS,
          FIRMA,
          SUBE_MUDURU,
          KAMU_MUHENDISI,
          KOMISYON_UYESI,
          KOMISYON_YEDEK_UYESI,
          UYGULAMA_YONETICISI,
          BAKANLIK_DAIRE_BASKANI,
          IL_MUDUR_YARDIMCISI,
          IL_MUDURU,
        ]) &&
          getItem(
            <NavLink onClick={toggleCollapsed} to={`${path}/proje/projelist/aktifProjelerim`}>
              {t('menu.proje.aktifProjelerim')}
            </NavLink>,
            'aktifProjelerim',
            null,
          ),

        hasRoles([
          MUHENDIS,
          SUBE_MUDURU,
          KAMU_MUHENDISI,
          KOMISYON_UYESI,
          KOMISYON_YEDEK_UYESI,
          UYGULAMA_YONETICISI,
          BAKANLIK_DAIRE_BASKANI,
          GENEL_MUDUR,
          GENEL_MUDUR_YARDIMCISI,
          IL_MUDUR_YARDIMCISI,
          IL_MUDURU,
        ]) &&
          getItem(
            <NavLink onClick={toggleCollapsed} to={`${path}/proje/projelist/imzaBekleyen`}>
              {t('menu.proje.imzaBekleyen')}
            </NavLink>,
            'imzaBekleyen',
            null,
          ),

        hasRoles([
          MUHENDIS,
          FIRMA,
          SUBE_MUDURU,
          KAMU_MUHENDISI,
          KOMISYON_UYESI,
          KOMISYON_YEDEK_UYESI,
          UYGULAMA_YONETICISI,
          BAKANLIK_DAIRE_BASKANI,
          IL_MUDUR_YARDIMCISI,
          IL_MUDURU,
        ]) &&
          getItem(
            <NavLink onClick={toggleCollapsed} to={`${path}/proje/projelist/arsivProjelerim`}>
              {t('menu.proje.arsivProjelerim')}
            </NavLink>,
            'arsivProjelerim',
            null,
          ),

        hasRoles([
          SUBE_MUDURU,
          KOMISYON_UYESI,
          UYGULAMA_YONETICISI,
          BAKANLIK_DAIRE_BASKANI,
          GENEL_MUDUR,
          GENEL_MUDUR_YARDIMCISI,
          IL_MUDUR_YARDIMCISI,
          IL_MUDURU,
        ]) &&
          getItem(
            <NavLink onClick={toggleCollapsed} to={`${path}/proje/projelist/tumProjeler`}>
              {t('menu.proje.tumProjeler')}
            </NavLink>,
            'tumProjeler',
            null,
          ),

        hasRoles([SUBE_MUDURU, KOMISYON_UYESI, KOMISYON_YEDEK_UYESI, UYGULAMA_YONETICISI, BAKANLIK_DAIRE_BASKANI]) &&
          getItem(
            <NavLink onClick={toggleCollapsed} to={`${path}/proje/projelist/komisyonProjeleri`}>
              {t('menu.proje.komisyonProjeleri')}
            </NavLink>,
            'komisyonProjeleri',
            null,
          ),

        hasRoles([
          SUBE_MUDURU,
          KOMISYON_UYESI,
          UYGULAMA_YONETICISI,
          BAKANLIK_DAIRE_BASKANI,
          GENEL_MUDUR,
          GENEL_MUDUR_YARDIMCISI,
        ]) &&
          getItem(
            <NavLink onClick={toggleCollapsed} to={`${path}/proje/projelist/ildenGelenProjeler`}>
              {t('menu.proje.ildenGelenProjeler')}
            </NavLink>,
            'ildenGelenProjeler',
            null,
          ),

        hasRoles([UYGULAMA_YONETICISI, BAKANLIK_DAIRE_BASKANI, SUBE_MUDURU, IL_SUBE_MUDURU]) &&
          getItem(
            <NavLink onClick={toggleCollapsed} to={`${path}/proje/projelist/muhendisTalepleri`}>
              {t('menu.proje.muhendisTalepleri')}
            </NavLink>,
            'muhendisTalepleri',
            null,
          ),

        hasRoles([
          SUBE_MUDURU,
          KAMU_MUHENDISI,
          KOMISYON_UYESI,
          KOMISYON_YEDEK_UYESI,
          UYGULAMA_YONETICISI,
          BAKANLIK_DAIRE_BASKANI,
          GENEL_MUDUR,
          GENEL_MUDUR_YARDIMCISI,
          IL_MUDUR_YARDIMCISI,
          IL_MUDURU,
        ]) &&
          getItem(
            <NavLink onClick={toggleCollapsed} to={`${path}/proje/projelist/2018OncesiArsiv`}>
              {t('menu.proje.2018OncesiArsiv')}
            </NavLink>,
            '2018OncesiArsiv',
            null,
          ),

        hasRoles([
          SUBE_MUDURU,
          KAMU_MUHENDISI,
          KOMISYON_UYESI,
          KOMISYON_YEDEK_UYESI,
          UYGULAMA_YONETICISI,
          BAKANLIK_DAIRE_BASKANI,
          GENEL_MUDUR,
          GENEL_MUDUR_YARDIMCISI,
          IL_MUDUR_YARDIMCISI,
          IL_MUDURU,
        ]) &&
          getItem(
            <NavLink onClick={toggleCollapsed} to={`${path}/proje/projelist/2018SonrasiArsiv`}>
              {t('menu.proje.2018SonrasiArsiv')}
            </NavLink>,
            '2018SonrasiArsiv',
            null,
          ),

        hasRoles([UYGULAMA_YONETICISI]) &&
          getItem(
            <NavLink onClick={() => setProjeDurumDegistirVisible(true)}>
              {t('menu.yonetim.projeDurumDegistir')}
            </NavLink>,
            'projeDurumDegistir',
            null,
          ),

        hasRoles([UYGULAMA_YONETICISI]) &&
          getItem(
            <NavLink onClick={() => setProjeYonetimiVisible(true)}>{t('menu.yonetim.projeYonetimi')}</NavLink>,
            'projeYonetimi2',
            null,
          ),

        hasRoles([UYGULAMA_YONETICISI]) &&
          getItem(
            <NavLink onClick={() => setReferansNoOlusturVisible(true)}>{t('menu.yonetim.referansNoOlustur')}</NavLink>,
            'referansNoOlustur',
            null,
          ),

        hasRoles([SUBE_MUDURU, BAKANLIK_DAIRE_BASKANI, KAMU_MUHENDISI, UYGULAMA_YONETICISI]) &&
          getItem(
            <NavLink onClick={toggleCollapsed} to={`${path}/tanimlar/formasyon/`}>
              {t('menu.tanimlar.formasyon')}
            </NavLink>,
            'formasyon',
            null,
          ),

        hasRoles([SUBE_MUDURU, BAKANLIK_DAIRE_BASKANI, KAMU_MUHENDISI, UYGULAMA_YONETICISI]) &&
          getItem(
            <NavLink onClick={toggleCollapsed} to={`${path}/tanimlar/litoloji/`}>
              {t('menu.tanimlar.litoloji')}
            </NavLink>,
            'litoloji',
            null,
          ),

        hasRoles([SUBE_MUDURU, BAKANLIK_DAIRE_BASKANI, KAMU_MUHENDISI, UYGULAMA_YONETICISI]) &&
          getItem(
            <NavLink onClick={toggleCollapsed} to={`${path}/management/addupdate/cihazbilgileri`}>
              {t('menu.yonetim.cihaz')}
            </NavLink>,
            'cihaz',
            null,
          ),
      ]),

    hasRoles([UYGULAMA_YONETICISI, BAKANLIK_DAIRE_BASKANI, SUBE_MUDURU]) &&
      getItem(t('menu.yonetim'), 'kullaniciYonetimi', !topMenu && <UilBuilding />, [
        hasRoles([UYGULAMA_YONETICISI, BAKANLIK_DAIRE_BASKANI, SUBE_MUDURU]) &&
          getItem(
            <NavLink onClick={toggleCollapsed} to={`${path}/kullanici/kurumkullanicilari/`}>
              {t('menu.yonetim.tumKullanicilar')}
            </NavLink>,
            'tumKullanicilar',
            null,
          ),
        hasRoles([UYGULAMA_YONETICISI]) &&
          getItem(<NavLink onClick={() => showModal()}>{t('menu.yonetim.tayinİslemi')}</NavLink>, 'firmalar', null),

        hasRoles([BAKANLIK_DAIRE_BASKANI, UYGULAMA_YONETICISI]) &&
          user.organizationId === YerbisConstants.NodeIds.Bakanlik &&
          getItem(
            <NavLink onClick={toggleCollapsed} to={`${path}/kullanici/anasayfa/`}>
              {t('menu.yonetim.kullanici')}
            </NavLink>,
            'kullanici',
            null,
          ),
        hasRoles([UYGULAMA_YONETICISI, BAKANLIK_DAIRE_BASKANI]) &&
          getItem(
            <NavLink onClick={toggleCollapsed} to={`${path}/kullanici/kullaniciGirisi`}>
              {t('menu.yonetim.kullaniciGirisi')}
            </NavLink>,
            'kullaniciGirisi',
            null,
          ),
        hasRoles([UYGULAMA_YONETICISI, BAKANLIK_DAIRE_BASKANI]) &&
          user.organizationId === YerbisConstants.NodeIds.Bakanlik &&
          getItem(
            <NavLink onClick={toggleCollapsed} to={`${path}/kurum/anasayfa/`}>
              {t('menu.yonetim.kurum')}
            </NavLink>,
            'kurum',
            null,
          ),

        hasRoles([UYGULAMA_YONETICISI]) &&
          getItem(
            <NavLink onClick={toggleCollapsed} to={`${path}/kullanici/kurumkullanicionay/`}>
              {t('menu.yonetim.kurumKullaniciOnay')}
            </NavLink>,
            'kurumKullaniciOnay',
            null,
          ),

        hasRoles([UYGULAMA_YONETICISI, BAKANLIK_DAIRE_BASKANI]) &&
          user.organizationId === YerbisConstants.NodeIds.Bakanlik &&
          getItem(
            <NavLink onClick={toggleCollapsed} to={`${path}/firma/anasayfa/`}>
              {t('menu.yonetim.firma')}
            </NavLink>,
            'firma',
            null,
          ),

        hasRoles([UYGULAMA_YONETICISI, BAKANLIK_DAIRE_BASKANI]) &&
          getItem(
            <NavLink onClick={toggleCollapsed} to={`${path}/muhendis/anasayfa/`}>
              {t('menu.yonetim.muhendis')}
            </NavLink>,
            'muhendis',
            null,
          ),

        hasRoles([UYGULAMA_YONETICISI]) &&
          getItem(
            <NavLink onClick={toggleCollapsed} to={`${path}/haberlerveduyurular/anasayfa`}>
              {t('menu.yonetim.haberlerDuyurular')}
            </NavLink>,
            'haberlerDuyurular',
            null,
          ),

        hasRoles([UYGULAMA_YONETICISI]) &&
          getItem(
            <NavLink onClick={toggleCollapsed} to={`${path}/servisler/anasayfa`}>
              {t('menu.yonetim.servisler')}
            </NavLink>,
            'servisler',
            null,
          ),
      ]),

    hasRoles([BAKANLIK_DAIRE_BASKANI]) &&
      getItem(t('menu.gorevlendirme'), 'gorevlendirmeYonetimi', !topMenu && <UilBuilding />, [
        getItem(
          <NavLink onClick={toggleCollapsed} to={`${path}/gorevlendirme/muhendisatamalari`}>
            {t('menu.gorevlendirme.muhendisAtamalari')}
          </NavLink>,
          'muhendisAtamalari',
          null,
        ),
        getItem(
          <NavLink onClick={toggleCollapsed} to={`${path}/gorevlendirme/ilmuhendistalepleri/`}>
            {t('menu.gorevlendirme.ilMuhendisTalepleri')}
          </NavLink>,
          'ilMuhendisTalepleri',
          null,
        ),
      ]),

    hasRoles([UYGULAMA_YONETICISI, BAKANLIK_DAIRE_BASKANI, GENEL_MUDUR, SUBE_MUDURU]) &&
      getItem(
        <NavLink onClick={fetchAndDownloadExcel}>{t('personelProjeDurumu')}</NavLink>,
        'personelProjeDurumu',
        null,
      ),

    hasRoles([UYGULAMA_YONETICISI, BAKANLIK_DAIRE_BASKANI, SUBE_MUDURU]) &&
      user.organizationId === YerbisConstants.NodeIds.Bakanlik &&
      getItem(
        <NavLink onClick={toggleCollapsed} to={`${path}/afetverianalizi/afetverianalizi`}>
          {t('afetVeriAnaliz')}
        </NavLink>,
        'afetVeriAnaliz',
        null,
      ),
  ];

  return (
    <>
      <Menu
        subMenuCloseDelay={1}
        onOpenChange={onOpenChange}
        onClick={onClick}
        mode={!topMenu || window.innerWidth <= 1050 ? 'inline' : 'horizontal'}
        // // eslint-disable-next-line no-nested-ternary
        defaultSelectedKeys={
          !topMenu
            ? [
                `${
                  mainPathSplit.length === 1 ? 'home' : mainPathSplit.length === 2 ? mainPathSplit[1] : mainPathSplit[2]
                }`,
              ]
            : []
        }
        defaultOpenKeys={!topMenu ? [`${mainPathSplit.length > 2 ? mainPathSplit[1] : 'dashboard'}`] : []}
        overflowedIndicator={<UilEllipsisV />}
        openKeys={openKeys}
        items={items}
      />
      {isModalVisible && <KullaniciTayinIslemi isModalVisible={isModalVisible} handleCancel={handleCancel} />}

      {projeDurumDegistirVisible && (
        <ProjeDurumDegistir visible={projeDurumDegistirVisible} onCancel={() => setProjeDurumDegistirVisible(false)} />
      )}

      {projeYonetimiVisible && (
        <ProjeYonetimi visible={projeYonetimiVisible} onCancel={() => setProjeYonetimiVisible(false)} />
      )}

      {referansNoOlusturVisible && (
        <ReferansNoOlustur
          isModalVisible={referansNoOlusturVisible}
          handleCancel={() => setReferansNoOlusturVisible(false)}
        />
      )}
    </>
  );
}

MenuItems.propTypes = {
  toggleCollapsed: propTypes.func,
};

export default MenuItems;
